const profileNames = {
  users: "Usuarios",
  profiles: "Perfiles",
  services: "Servicios",
  clients: "Clientes",
  chats: "Chats",
};

const permissionsName = {
  view: "Ver",
  delete: "Borrar",
  edit: "Edición",
  register: "Registro",
  reply: "Responder",
};

const servicesName = {
  id: "ID",
  CAAT: "CAAT",
  alphaCode: "Código alfa",
  basculePermission: "Permiso de báscula",
  buyerID: "ID del comprador",
  clientID: "ID del cliente",
  compannyCommentID: "ID del comentario de la empresa",
  compannyComment: "Comentario de la empresa",
  creationDate: "Fecha de creación",
  driverID: "ID del conductor",
  economicCode: "Código económico",
  feet: "Pies",
  integrationNumber: "Número de integración",
  manifestNumber: "Número de manifiesto",
  overweightPermission: "Permiso de sobrepeso",
  phytosanitaryPermission: "Permiso fitosanitario",
  plateNumber: "Número de placa",
  travelNumber: "Número de viaje",
  phone: "Teléfono",
  invoiceNumber: "Número de factura",
  moduleStatus: "Estado del módulo",
  requirementNumber: "Número de requerimiento",
  modificationDate: "Fecha de modificación",
  isDeleted: "¿Está eliminado?",
  statusID: "ID de estado",
  userId: "ID de usuario",
  client: "Cliente",
  status: "Estado",
  buyer: "Comprador",
  driver: "Conductor",
  servicesObservations: "Observaciones de servicios",
  navigate: "Navegar",
};

const sheetNames = {
  creationDate: "Fecha de creación",
  client: "Cliente MX",
  buyer: "Cliente USD",
  invoiceNumber: "Número de factura",
  economicCode: "Código económico",
  feet: "Pies",
  alphaCode: "Código alfa",
  CAAT: "Código CAAT",
  plateNumber: "Número de placa",
  integrationNumber: "Número de integración",
  servicesObservations: "Observaciones de servicios",
  requirementNumber: "Pedimento",
  remesas: "Remesa",
  travelNumber: "Número de viaje",
  moduleStatus: "Módulo",
  phytosanitaryPermission: "Fitosanitario",
  basculePermission: "Báscula",
  overweightPermission: "Permiso de sobrepeso",
};

export const getNameProfile = (name = "") => {
  return profileNames[name];
};

export const getPermission = (permission = "") => {
  return permissionsName[permission];
};

export const getService = (service = "") => {
  return servicesName[service];
};

export const remapProperties = (obj) => {
  const newObj = {};
  for (let key in obj) {
    if (sheetNames[key]) {
      newObj[sheetNames[key]] = obj[key];
    }
  }
  return newObj;
};
